<script setup>

const commercialStore = useCommercialStore()
const raionsStore = useRaionsStore()


commercialStore.seo_mode = true
const app_config = useAppConfig()
const { params } = useRoute()
const { offertype, type, name } = params

const page_title = ref('-')
const page_header = ref('-')
const query = {}
await raionsStore.getList()

;(async () => {
    const raion = raionsStore.items.find( r => r.slug == name && r.city_id == commercialStore.filter.city_id ) 
    if( offertype && app_config[offertype] ){
        let data_offertype = app_config[offertype]
        let data_type = data_offertype.types.find( e => e.slug == type )
        let header = capitalize( `${data_offertype.header} ${data_type.vin} в ${raion.seo_pred} районе ${app_config.city.rod}` )
        page_header.value = header
        page_title.value = header
        query.offertype = offertype
        query.raions = raion.id.toString()
        query.type = type

        query.metros = ''
        query.page = 1
        query.area_ot = ''
        query.area_do = ''
        query.price_ot = ''
        query.price_do = ''
    }
    useSeoMeta({
        title: page_title.value,
    })
})()

const objBreadcrumb = {
    offerType: app_config[offertype],
    data_type: app_config[offertype].types.find( e => e.slug == type ),
    raion: raionsStore.items.find( r => r.slug == name && r.city_id == commercialStore.filter.city_id ),
}

</script>
<template>
    
    <LayoutsCatalog :header="page_header" :seo_mode="true" :objBreadcrumb="objBreadcrumb" >
        <template #filter>
            <Filter :query="query" :autorun="true" />
        </template>
    </LayoutsCatalog>

</template>